import { Card, Row, Col } from 'react-bootstrap';
import { 
    FaCalendarCheck, 
    FaUmbrellaBeach, 
    FaUserPlus,
    FaBuilding
} from 'react-icons/fa';

const ReportTypeSelector = ({ selectedType, onTypeChange }) => {
    const reportTypes = [
        {
            id: 'attendance',
            title: 'Monthly Attendance',
            description: 'Track employee attendance, present/absent days',
            icon: <FaCalendarCheck size={24} />,
            color: '#4472C4'
        },
        {
            id: 'leave',
            title: 'Leave Summary',
            description: 'View leave balances and requests',
            icon: <FaUmbrellaBeach size={24} />,
            color: '#70AD47'
        },
        {
            id: 'employee-movement',
            title: 'Employee Joining/Exit',
            description: 'Track new joinings and exits',
            icon: <FaUserPlus size={24} />,
            color: '#A5A5A5'
        },
        {
            id: 'department-wise',
            title: 'Department-wise Attendance',
            description: 'Monthly attendance by department',
            icon: <FaBuilding size={24} />,
            color: '#636363'
        }
    ];

    return (
        <Card className="shadow-sm border-0">
            <Card.Body className="p-4">
                <h5 className="mb-3 fw-bold">Select Report Type</h5>
                <Row>
                    {reportTypes.map((report) => (
                        <Col key={report.id} md={3} sm={6} className="mb-3">
                            <div
                                className={`report-type-card ${selectedType === report.id ? 'active' : ''}`}
                                onClick={() => onTypeChange(report.id)}
                                style={{
                                    cursor: 'pointer',
                                    padding: '20px',
                                    borderRadius: '8px',
                                    border: selectedType === report.id ? `2px solid ${report.color}` : '2px solid #e0e0e0',
                                    backgroundColor: selectedType === report.id ? `${report.color}15` : '#fff',
                                    transition: 'all 0.3s ease',
                                    height: '100%'
                                }}
                                onMouseEnter={(e) => {
                                    if (selectedType !== report.id) {
                                        e.currentTarget.style.borderColor = report.color;
                                        e.currentTarget.style.backgroundColor = `${report.color}08`;
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (selectedType !== report.id) {
                                        e.currentTarget.style.borderColor = '#e0e0e0';
                                        e.currentTarget.style.backgroundColor = '#fff';
                                    }
                                }}
                            >
                                <div className="d-flex align-items-center mb-2">
                                    <div
                                        style={{
                                            color: report.color,
                                            marginRight: '12px'
                                        }}
                                    >
                                        {report.icon}
                                    </div>
                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '14px' }}>
                                        {report.title}
                                    </h6>
                                </div>
                                <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
                                    {report.description}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ReportTypeSelector;
